/** SIP agent extensions available in the softphone quick-dial list (counselor01 … counselor25). */
export const COUNSELOR_EXTENSION_OPTIONS = Array.from({ length: 25 }, (_, index) => {
    const ext = `counselor${String(index + 1).padStart(2, '0')}`;
    return { label: ext, value: ext };
});
const COUNSELOR_EXTENSION_RE = /^counselor(\d{1,2})$/i;
/** counselor01 … counselor25 → PBX extension 101 … 125 (used in 901/902/903/905 dial strings). */
export function counselorIndexToPbxExtension(index) {
    if (!Number.isFinite(index) || index < 1 || index > 25)
        return '';
    return String(100 + index);
}
/** Parse `counselor01` style SIP names → `101`. Returns '' when not a counselor extension. */
export function parseCounselorPbxExtension(phoneUser) {
    const match = phoneUser.trim().match(COUNSELOR_EXTENSION_RE);
    if (!match)
        return '';
    return counselorIndexToPbxExtension(parseInt(match[1], 10));
}
/**
 * Resolve an agent id for supervisor keypad dials (`901`/`902`/`903`/`905` + digits).
 * Numeric extensions pass through; `counselor01` … `counselor25` map to `101` … `125`.
 */
export function resolveSupervisorAgentDialDigits(agentExtension) {
    const trimmed = agentExtension.trim();
    if (!trimmed)
        return '';
    const counselorDigits = parseCounselorPbxExtension(trimmed);
    if (counselorDigits)
        return counselorDigits;
    const digits = trimmed.replace(/\D/g, '');
    return digits;
}
